<template>
    <div ref="cloud" class="icon-cloud" />
  </template>
  
  <script>
  import TagCloud from 'tagcloud';
  
  export default {
    name: 'IconCloud',
    props: {
      // Array of icon URLs
      items: {
        type: Array,
        required: true, // e.g. ['/icons/vue.svg', '/icons/react.png', '/icons/angular.svg']
      },
      options: {
        type: Object,
        default: () => ({
          radius: 140,         // px
          maxSpeed: 'normal',  // 'slow', 'normal', 'fast'
          initSpeed: 'normal',
          keep: true           // keep spinning after mouse leaves
        })
      }
    },
    mounted() {
      // Create simple text labels for TagCloud positioning
      const labels = this.items.map((url, index) => `icon-${index}`);
      
      // Initialize TagCloud with simple text labels
      this._cloud = TagCloud(this.$refs.cloud, labels, this.options);
      
      // After TagCloud creates the structure, modify existing elements to show images
      this.$nextTick(() => {
        const cloudElements = this.$refs.cloud.querySelectorAll('span');
        cloudElements.forEach((element, index) => {
          if (index < this.items.length) {
            const url = this.items[index];
            const filename = url.split('/').pop().split('.')[0];
            
            // Clear the text content
            element.textContent = '';
            
            // Set the element's background image instead of replacing it
            element.style.backgroundImage = `url(${url})`;
            element.style.backgroundSize = 'contain';
            element.style.backgroundRepeat = 'no-repeat';
            element.style.backgroundPosition = 'center';
            element.style.width = '32px';
            element.style.height = '32px';
            element.style.display = 'inline-block';
            element.className = 'cloud-icon';
            
            // Add alt text as a data attribute for accessibility
            element.setAttribute('data-alt', filename);
          }
        });
      });
    },
    beforeDestroy() {
      // TagCloud returns an instance with a destroy method (in recent versions)
      if (this._cloud && this._cloud.destroy) this._cloud.destroy();
    }
  };
  </script>
  
  <style scoped>
  .cloud-icon {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 32px;
    height: 32px;
    display: inline-block;
    border-radius: 5px;
    overflow: hidden;
  }

  .icon-cloud {
    width: 100%;
    height: 320px;
    position: relative;
    /* Optional: centre it nicely inside a card/section */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-cloud a,
  .icon-cloud span,
  .icon-cloud img {
    /* tweak sizing/appearance of entries */
    display: inline-block;
    font-size: 14px;
    line-height: 1;
  }
  .icon-cloud img,
  .icon-cloud .cloud-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
    transition: transform 0.2s ease;
  }
  .icon-cloud img:hover,
  .icon-cloud .cloud-icon:hover {
    transform: scale(1.1);
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/iconCloud.vue